import styled from 'styled-components';

export const StyledPopupWrapper = styled.div`
  min-width: 300px;
  padding: 15px;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
`;
